// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20602-购物车新增 添加商品到购物车，需选择具体时段 POST /app/v1/cart/add */
export async function addCart(
  body: API.SwimCartAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/app/v1/cart/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20603-购物车删除 从购物车删除商品 GET /app/v1/cart/delete/${param0} */
export async function deleteCart(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteCartParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/app/v1/cart/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 20601-购物车列表查询 查询当前用户的购物车列表 GET /app/v1/cart/list */
export async function getCartList(options?: { [key: string]: any }) {
  return request<API.YmResultVOListSwimCartListVo>("/app/v1/cart/list", {
    method: "GET",
    ...(options || {}),
  });
}
